"use client";

import { useTranslation } from "react-i18next";

type FormStatusMessagesProps = {
  status: "success" | "error" | null;
  errorMessage?: string | null;
};

export function FormStatusMessages({ status, errorMessage }: FormStatusMessagesProps) {
  const { t } = useTranslation();

  if (status === "success") {
    return (
      <div
        role="alert"
        aria-live="polite"
        className="p-6 bg-green-50 border-2 border-green-300 text-green-900 rounded-none space-y-2"
      >
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <h4 className="font-semibold">{t("Message Sent Successfully!")}</h4>
        </div>
        <p className="text-sm">{t("Your message has been sent successfully! We will contact you soon.")}</p>
        <p className="text-xs text-green-700 mt-2">
          {t("Expected response time: 24-48 hours")}
        </p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div
        role="alert"
        aria-live="assertive"
        className="p-6 bg-red-50 border-2 border-red-300 text-red-900 rounded-none space-y-2"
      >
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
          <h4 className="font-semibold">{t("Error Sending Message")}</h4>
        </div>
        <p className="text-sm">
          {errorMessage || t("An error occurred while sending. Please try again or contact us directly.")}
        </p>
      </div>
    );
  }

  return null;
}

